import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { UserDetail } from '@/entities/user/domain';

export const getUserDetail = async (userName: string): Promise<UserDetail> => {
  const response = await openMetadataApiClient.get<UserDetail>(`/users/name/${userName}`, {
    params: {
      fields: 'teams,roles,profile',
    },
  });
  return response.data;
};
